<template>
  <div v-if="tableData.length">
    <div>
      <span>已申请发货信息</span>
    </div>
    <Collapse v-for="(data, index) in tableData" :key="index">
      <div slot="header">
        <div class="headerItem">
          <span>
            配送至：
            {{ data.receiptAddressInfo?.province }}
            {{ data.receiptAddressInfo?.city }}
            {{ data.receiptAddressInfo?.county }}
            {{ data.receiptAddressInfo?.receiptAddress }}
            {{ data.receiptAddressInfo?.receiverName }}
            {{ data.receiptAddressInfo?.receiverPhone }}
          </span>
          <span>
            &nbsp;&nbsp;&nbsp;&nbsp;实际结算金额总计：{{ data?.settlementAmountTotal }}元
          </span>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;发货数量总计：{{ data?.productNumTotal }}</span>
        </div>
      </div>
      <div v-for="item in data.strategyShipmentInfos" :key="item.id">
        <div class="Shipped-box">
          <span>&nbsp;&nbsp;&nbsp;&nbsp;申请单号：
            <span
              style="color: #53a8ff; display: inline-block; cursor: pointer"
              @click="batchApplicationNumber(item)"
            >
              {{ item.deliveryNum }}
            </span></span>
          <span>申请日期：{{ item.createTime }}</span>
          <span>发货单号：{{ item.invoiceNum }}</span>
        </div>
        <el-table v-loading="loading" :data="item.strategyShipmentProducts" border style="width: 100%" show-summary :summary-method="getSummaries">
          <el-table-column
            type="index"
            label="序号"
            align="left"
            fixed="left"
            width="50"
          />
          <el-table-column
            prop="materialNumber"
            label="物品代码"
            align="left"
          />
          <el-table-column
            prop="productName"
            label="物品名称"
            align="left"
          />
          <el-table-column prop="productNum" label="数量" align="left" />
          <el-table-column
            prop="productPriceSigle"
            label="实际结算单价"
            align="right"
            header-align="left"
            width="160"
          />
          <el-table-column
            prop="settlementAmount"
            label="实际结算金额"
            align="right"
            header-align="left"
            width="160"
          />
          <el-table-column
            prop="expectedDeliveryDate"
            label="客户期望发货日"
            align="left"
          >
            <template v-slot="{ row }">
              {{ row.expectedDeliveryDate.substring(0, 10) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="agreedDate"
            label="约定交付日期"
            align="left"
          >
            <template v-slot="{ row }">
              {{ row.agreedDate.substring(0, 10) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </Collapse>
    <!-- 订单详情 -->
    <orderDetails
      ref="orderDetails"
    />
  </div>
</template>

<script>
import Collapse from '@/components/Collapse';
import { queryShippingInfoSpecialProducts } from '@/API';
import orderDetails from '../order-details/index.vue';
import { MathAdd } from '@/libs/util';

export default {
  data () {
    return {
      tableData: [],
      loading: false
    };
  },
  components: {
    Collapse,
    orderDetails
  },
  props: {
    infoData: {
      type: [String, Number, Object],
      required: true
    }
  },
  mounted () {
    this.initData();
  },

  methods: {
    initData () {
      this.loading = true;
      queryShippingInfoSpecialProducts(this.infoData.id).then((res) => {
        this.loading = false;
        let { status, data } = res.data;
        if (status === '200') {
          this.tableData = data.strategyShipmentVO;
        }
      }).catch(() => {
        this.loading = false;
      });
    },

    batchApplicationNumber (val) {
      this.$refs.orderDetails.openDialog(val);
    },

    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns && columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.settlementAmount(param.data);
        }
      });
      return sums;
    },

    productNum (target) {
      let cont = 0;
      target && target.forEach((item) => {
        cont = MathAdd(cont, item.productNum);
      });
      return cont;
    },
    settlementAmount (target) {
      let cont = 0;
      target && target.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    }
  }
};
</script>

<style lang="scss" scoped>

.Shipped-box{
  height: 40px;
  span{
    line-height: 40px;
    margin-right: 25px;
  }
}
</style>
